import { useGetConfigVar } from '@/composables/useGetConfigVar'
import { EngineerSessionLocationVerificationMethod } from '@/enums/EngineerSessionLocationVerificationMethod'

/**
 *
 * @param {string} configVarName Either the config var name or the value of the config var.
 * @returns {boolean}
 */
export function isLocationEnabled(configVarName) {
  return (
    [
      EngineerSessionLocationVerificationMethod.GEOLOCATION,
      EngineerSessionLocationVerificationMethod.GEOLOCATION_AND_ACCESS_CODE,
    ].find((item) => {
      let configVar = null

      try {
        configVar = useGetConfigVar(configVarName)
      } catch (error) {
        configVar = configVarName
      }

      return item === configVar
    }) !== undefined
  )
}

/**
 *
 * @param {string} configVarName Either the config var name or the value of the config var.
 * @returns {boolean}
 */
export function isAccessCodeEnabled(configVarName) {
  return (
    [
      EngineerSessionLocationVerificationMethod.ACCESS_CODE,
      EngineerSessionLocationVerificationMethod.GEOLOCATION_AND_ACCESS_CODE,
    ].find((item) => {
      let configVar = null

      try {
        configVar = useGetConfigVar(configVarName)
      } catch (error) {
        configVar = configVarName
      }

      return item === configVar
    }) !== undefined
  )
}
